<template>
  <div class="c-box">
    <loader :loading="sending || loading"/>
    <header class="c-box__heading" @click="toggleProductInfo()">
      <span v-once>{{ product.title }}</span>
      <i v-bind:class="toggleIconClass()" class="u-floatRight"></i>
      <span v-if="productStatus && productStatus !== 'sending'" slot="header-right" class="badge u-floatRight status" v-bind:class="productStatus">{{ $t(`${productStatus}.label`) }}</span>
    </header>
    <div class="c-box__body" v-show="show">
      <div class="c-box__inner">

        <general-main :product="product"/>

        <general-category :product="product" @change="clearInfos" v-on:searchCategoryInfo="searchCategoryInfo" v-on:loading="isLoader"/>

        <general-details :product="product" :category="infos" :announcementConfigurations="announcementConfigurations" v-if="infos.settings && !loading" :defaultTypeCheckout="typeCheckout" v-on:changeTypeCheckout="(v) => typeCheckout = v" />

        <panel title="Tipo de Variação" v-if="isUseVariationCombination">
          <div class="l-row">
            <form-group label="Tipo" :columns="12" :required="true">
              <select class="form-select" v-model="variationsCombination">
                <option :value=null>{{ $t('choose.label') }}</option>
                <option v-for="variationCombination in infos.variations_combinations" :key="variationCombination" :value="variationCombination.id">{{ variationCombination.name }}</option>
              </select>
            </form-group>
          </div>
        </panel>

        <panel title="Atributos" v-if="(infos.attributes.length && !isUseVariationCombination) || (variationsCombination !== null && isUseVariationCombination)">
          <general-attributes :product="product" :attributes="infos.attributes" :announcementConfigurations="announcementConfigurations"/>
        </panel>

        <fiscal-attributes :product="product"></fiscal-attributes>

        <product-edit-bulk-price :fromModule="fromModule" :product="product" v-if="(infos.settings && !isUseVariationCombination) || (variationsCombination !== null && isUseVariationCombination)"/>

        <variation :product="product" :category="infos" v-if="(infos.settings && !isUseVariationCombination) || (variationsCombination !== null && isUseVariationCombination)" :fromModule="fromModule" :typeCheckout="typeCheckout" v-on:changeTypeCheckout="(v) => typeCheckout = v"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import Loader from '@/components/template/Loader'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import GeneralMain from '@/components/marketplace/mercadoLivre/announcement/general/Main'
  import GeneralCategory from '@/components/marketplace/mercadoLivre/announcement/general/Category'
  import GeneralAttributes from '@/components/marketplace/mercadoLivre/announcement/general/Attributes'
  import GeneralDetails from '@/components/marketplace/mercadoLivre/announcement/general/Details'
  import FiscalAttributes from '@/components/marketplace/mercadoLivre/announcement/general/FiscalAttributes'
  import Variation from '@/components/marketplace/mercadoLivre/announcement/Variation'
  import ProductEditBulkPrice from '@/components/marketplace/shared/ProductEditBulkPrice'
  import notifier from '@/notifier'

  export default {
    inject: ['moduleDI'],
    data: () => ({
      show: false,
      infos: {
        attributes: []
      },
      loading: false,
      variationsCombination: null,
      typeCheckout: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      announcementConfigurations: {
        type: Array,
        required: true
      }
    },
    created () {
      this.variationsCombination = null
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      isLoader (status) {
        this.loading = status
      },
      toggleProductInfo () {
        if (this.productStatus === 'sent' || this.productStatus === 'error') {
          return false
        }

        this.show = !this.show
      },
      toggleIconClass () {
        return {
          'icon-circle-up': this.show,
          'icon-circle-down': !this.show
        }
      },
      statusSendIconClass () {
        return {
          'icon-checkmark t-success': this.productStatus === 'sent',
          'icon-cross t-error': this.productStatus === 'error',
          'icon-cross t-warning': this.productStatus === 'to-fix'
        }
      },
      getClassStatusVariation (variation) {
        return {
          'success': variation.status === 'sent',
          'error': variation.status === 'error'
        }
      },
      async searchCategoryInfo (categoryId, variationCombination) {
        this.loading = true

        if (this.variationCombination === null && this.isUseVariationCombination) {
          this.loading = false
          return
        }

        try {
          const accountId = await api.mercadoLivre.getActiveAccountId()
          this.infos = await api.mercadoLivre.getCategoryInfo(accountId, categoryId, variationCombination)
        } catch (e) { }

        this.loading = false
      },
      formatProduct () {
        this.clearErrors()

        if (this.product.categories[this.product.categories.length - 1] === null) {
          this.addError({
            productId: this.product.productId,
            sku: this.product.productId,
            property: 'categories',
            error: {
              message: 'required',
              value: 1
            }
          })
          throw new Error('Selecione toda a árvore de categorias.')
        }

        const attributes = this.product.attributes

        const productAttributes = []

        if (this.isUseUniquePrice(this.product.productId)) {
          const productUniquePrice = this.getProductUniquePrice(this.product.productId)

          if (productUniquePrice !== undefined) {
            for (let i in this.product.variations) {
              this.product.variations[i].price = productUniquePrice.price
            }
          }
        }

        for (let i in Object.keys(attributes)) {
          const attributeId = Object.keys(attributes)[i]
          const attributeValueId = attributes[attributeId]
          const attribute = this.infos.attributes.find(attribute => attribute.id === attributeId)

          if (!attribute) continue

          if ((attribute.tags && attribute.tags.required || attribute.required) && attributeValueId === null) {
            this.addError({
              productId: this.product.productId,
              sku: this.product.productId,
              property: attributeId,
              error: {
                message: 'required',
                value: 1
              }
            })
          }

          if (attributeValueId !== null && attributeValueId !== '') {
            let complement = ''
            if (attribute.default_unit) {
              complement = ' ' + attribute.default_unit
            }

            let attributeTemp = {
              id: attributeId,
              value_name: attributeValueId + complement
            }

            if (attribute.values) {
              const attributeValueName = attribute.values.find(value => value.id === attributeValueId)

              if (attributeValueName) {
                if (!attributeValueName.custom) {
                  attributeTemp.value_id = attributeValueName.id
                }
                attributeTemp.value_name = attributeValueName.name
              }
            }

            if (attributeId === 'MODEL' || attributeId === 'COLOR' || attributeId === 'TEAM') {
              attributeTemp.value_id = attributeTemp.value_name
            }

            productAttributes.push(attributeTemp)
          }
        }

        let variations = null
        if (this.infos.variations_combinations.length) {
          variations = this.product.variations
            .filter(variation => variation.selected)
            .map(variation => {
              const attributes = variation.attributes

              const variationAttributes = []
              for (let i in Object.keys(attributes)) {
                const attributeId = Object.keys(attributes)[i]
                const attributeValueId = attributes[attributeId]

                const attribute = this.infos.variations_attributes.find(attribute => attribute.id === attributeId)

                if (!attribute) continue

                if ((attribute.tags && attribute.tags.required || attribute.required || attribute.attributeUsedAsVariation) && attributeValueId === null) {
                  this.addError({
                    productId: this.product.productId,
                    sku: variation.sku,
                    property: attributeId,
                    error: {
                      message: 'required',
                      value: 1
                    }
                  })
                }

                if (attributeValueId !== null && attributeValueId !== '') {
                  let complement = ''
                  if (attribute.default_unit) {
                    complement = ' ' + attribute.default_unit
                  }
                  let attributeTemp = {
                    id: attributeId,
                    name: attribute.name,
                    value_name: attributeValueId + complement
                  }

                  if (attribute.values) {
                    const attributeValueName = attribute.values.find(value => value.id === attributeValueId)

                    if (attributeValueName) {
                      if (!attributeValueName.custom) {
                        attributeTemp.value_id = attributeValueName.id
                      }
                      attributeTemp.value_name = attributeValueName.name + complement
                    }
                  }

                  variationAttributes.push(attributeTemp)
                }
              }

              return {
                attributes: variationAttributes,
                images: variation.images.length ? variation.images : null,
                original: variation,
                price: variation.price,
                sku: variation.sku,
                stock: variation.stock
              }
            })
        } else {
          const attributes = this.product.variation.attributes

          const variationAttributes = []
          for (let i in Object.keys(attributes)) {
            const attributeId = Object.keys(attributes)[i]
            const attributeValueId = attributes[attributeId]

            const attribute = this.infos.variations_attributes.find(attribute => attribute.id === attributeId)

            if (!attribute) continue

            if ((attribute.tags && attribute.tags.required || attribute.required) && attributeValueId === null) {
              this.addError({
                productId: this.product.productId,
                sku: this.product.variation.sku,
                property: attributeId,
                error: {
                  message: 'required',
                  value: 1
                }
              })
            }

            if (attributeValueId !== null && attributeValueId !== '') {
              let complement = ''
              if (attribute.default_unit) {
                complement = ' ' + attribute.default_unit
              }
              let attributeTemp = {
                id: attributeId,
                name: attribute.name,
                value_name: attributeValueId + complement
              }

              if (attribute.values) {
                const attributeValueName = attribute.values.find(value => value.id === attributeValueId)

                if (attributeValueName) {
                  if (!attributeValueName.custom) {
                    attributeTemp.value_id = attributeValueName.id
                  }
                  attributeTemp.value_name = attributeValueName.name + complement
                }
              }

              variationAttributes.push(attributeTemp)
            }
          }

          variations = [
            {
              attributes: variationAttributes,
              images: this.product.variation.images.length ? this.product.variation.images : null,
              original: this.product.variation,
              price: this.product.variation.price,
              sku: this.product.variation.sku,
              stock: this.product.variation.stock
            }
          ]
        }

        const accountsAnnouncements = []

        for (let i in this.announcementConfigurations) {
          const configuration = this.announcementConfigurations[i]

          if (this.product.medAnvisaCode === '') {
            this.product.medAnvisaCode = 'ISENTO'
          }

          const product = {
            productIdentifier: i,
            attributes: productAttributes,
            brand: this.product.brand,
            category: this.product.categories.slice(-1)[0],
            condition: this.product.condition,
            description: this.product.description,
            original: this.product,
            productId: this.product.productId,
            shippingMode: this.product.shippingMode,
            shippingFree: configuration.shippingFree,
            shippingFreeRule: this.product.shippingFreeRule[configuration.account.identifier],
            source: this.fromModule,
            title: this.product.title,
            type: configuration.announcementType,
            variations: variations,
            ncm: this.product.ncm,
            originType: this.product.originType,
            originDetail: this.product.originDetail,
            csosn: this.product.csosn,
            cest: this.product.cest,
            fci: this.product.fci,
            taxRuleId: this.product.taxRuleId,
            exTipi: this.product.exTipi,
            medAnvisaCode: this.product.medAnvisaCode,
            medExemptionReason: this.product.medExemptionReason,
            netWeight: this.product.netWeight,
            grossWeight: this.product.grossWeight,
            variationsCombination: this.variationsCombination,
            status: this.product.status,
            typeCheckout: this.product.typeCheckout,
            productCatalogId: this.product.productCatalogId,
            account: {
              identifier: configuration.account.identifier
            },
            officialStoreId: configuration.officialStore && configuration.officialStore.code !== 'none' ? configuration.officialStore.code : null
          }

          accountsAnnouncements.push(product)
        }

        return accountsAnnouncements
      },
      clearInfos () {
        this.infos = {
          attributes: []
        }
        this.product.attributes = []
      }
    },
    computed: {
      ...mapGetters('sendAnnouncements', [
        'getItem'
      ]),
      ...mapGetters('errors', [
        'getError'
      ]),
      ...mapGetters('editPrices', [
        'isUseUniquePrice',
        'getProductUniquePrice'
      ]),
      productItem () {
        return this.getItem(this.product.productId)
      },
      productStatus () {
        if (!this.productItem) {
          return false
        }
        return this.productItem.status
      },
      sending () {
        if (!this.productItem) {
          return false
        }
        return this.productStatus === 'sending'
      },
      isUseVariationCombination () {
        return this.infos.variations_combinations !== undefined && this.infos.variations_combinations.length && !this.typeCheckout
      }
    },
    watch: {
      'infos.attributes' (value) {
        this.product.attributes = []

        for (let i in value) {
          let attribute = this.product.attributes[value[i].id]

          if (attribute === undefined) {
            this.product.attributes[value[i].id] = null
          }

          if (value[i].id === 'BRAND') {
            this.product.attributes[value[i].id] = null

            try {
              let valueAttributeBrand = value[i].values.find(attributeValue => attributeValue.name === this.product.brand)

              if (valueAttributeBrand !== undefined) {
                this.product.attributes[value[i].id] = valueAttributeBrand.id
              }
            } catch (error) {
              notifier.error('Nenhuma marca vinculada a categoria selecionada. Preencha ou selecione marca customizada', 'Erro')
            }

            value[i].values = [{
              'id': this.product.brand,
              'name': this.product.brand
            }]
          }

          if (value[i].id === 'LENGTH') {
            this.product.attributes[value[i].id] = null
            if (this.product.variations[0] && this.product.variations[0]['length']) {
              this.product.attributes[value[i].id] = this.product.variations[0]['length']
            }
          }

          if (value[i].id === 'PILLOW_HEIGHT') {
            this.product.attributes[value[i].id] = null
            if (this.product.variations[0] && this.product.variations[0]['height']) {
              this.product.attributes[value[i].id] = this.product.variations[0]['height']
            }
          }

          if (value[i].id === 'SELLER_PACKAGE_WIDTH') {
            this.product.attributes[value[i].id] = null
            if (this.product.variations[0] && this.product.variations[0]['width']) {
              this.product.attributes[value[i].id] = this.product.variations[0]['width']
            }
          }

          if (value[i].id === 'SELLER_PACKAGE_LENGTH') {
            this.product.attributes[value[i].id] = null
            if (this.product.variations[0] && this.product.variations[0]['length']) {
              this.product.attributes[value[i].id] = this.product.variations[0]['length']
            }
          }

          if (value[i].id === 'SELLER_PACKAGE_HEIGHT') {
            this.product.attributes[value[i].id] = null
            if (this.product.variations[0] && this.product.variations[0]['height']) {
              this.product.attributes[value[i].id] = this.product.variations[0]['height']
            }
          }

          if (value[i].id === 'SELLER_PACKAGE_WEIGHT') {
            this.product.attributes[value[i].id] = null
            if (this.product.variations[0] && this.product.variations[0]['weight']) {
              this.product.attributes[value[i].id] = this.product.variations[0]['weight']
            }
          }

          if (value[i].id === 'GENDER') {
            for (const variation of this.product.variations) {
              let currentGender = this.product.attributes[value[i].id]
              if (currentGender === null) {
                this.product.attributes[value[i].id] = variation.gender
                currentGender = variation.gender
              }
              if (currentGender !== variation.gender) {
                this.product.attributes[value[i].id] = null
                break
              }
              this.product.attributes[value[i].id] = variation.gender
            }
            let valueAttributeGender = ''
            switch (this.product.attributes[value[i].id]) {
              case 'male':
                valueAttributeGender = value[i].values.find(attributeValue => attributeValue.name === 'Masculino')
                this.product.attributes[value[i].id] = valueAttributeGender.id
                break

              case 'female':
                valueAttributeGender = value[i].values.find(attributeValue => attributeValue.name === 'Feminino')
                this.product.attributes[value[i].id] = valueAttributeGender.id
                break

              case 'unisex':
                valueAttributeGender = value[i].values.find(attributeValue => attributeValue.name === 'Sem gênero')
                this.product.attributes[value[i].id] = valueAttributeGender.id
                break
            }
          }
        }
      },
      variationsCombination (newValue) {
        this.searchCategoryInfo(this.product.categories.slice(-1)[0], newValue)

        this.product.variationsCombination = newValue
      },
      typeCheckout (value) {
        this.product.typeCheckout = value
      }
    },
    components: {
      Loader,
      Panel,
      FormGroup,
      GeneralMain,
      GeneralCategory,
      GeneralAttributes,
      FiscalAttributes,
      GeneralDetails,
      Variation,
      ProductEditBulkPrice
    }
  }
</script>

<style lang="sass" scoped>
  .c-box
    margin-bottom: 16px

  .c-box__body
    background: #d9edf7

  .c-box__heading
    cursor: pointer
    height: 50px
    line-height: 2
    font-size: 15px
    color: #31708f
    background-color: #d9edf7
    border-color: #bde2fb

  .icon-circle-down, .icon-circle-up
    font-size: 30px

  .c-box__body
    border-color: #bde2fb

  .divider
    margin-bottom: 16px

  .status
    margin-right: 20px
    margin-top: 4px
</style>



// WEBPACK FOOTER //
// Product.vue?4cd42083